import { Tag } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { FaSearch } from "react-icons/fa";
import { useState } from "react";
import ModalConciliar from "../ModalConciliar";
import { OperacaoEnum } from "core/resources/enums/conta";
import { checkPermission } from "infra/helpers/permission";
import { PermissaoEnum } from "core/resources/enums/permissao";

interface TagStatusConciliacaoProps {
  mb?: string;
  valor: number;
  conciliado?: boolean | null;
  operacao: OperacaoEnum;
  extratoId: string;
  extratoData: string;
  tenantContaIdExtrato: string;
  mes: string;
  refetch?: () => any;
  contasBancariasIds?: string[];
}

function TagStatusConciliacao({
  mb,
  valor,
  conciliado = false,
  operacao,
  extratoId,
  extratoData,
  tenantContaIdExtrato,
  mes,
  refetch,
  contasBancariasIds,
}: TagStatusConciliacaoProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const hasPermissionTagConciliar =
    conciliado ||
    checkPermission(
      PermissaoEnum.Backoffice.Financeiro.ConciliacaoBancaria.Conciliar
    );

  return (
    <>
      {hasPermissionTagConciliar ? (
        <Tag
          bg={conciliado ? colors.green1000 : colors.blue}
          borderRadius={conciliado ? 14 : 4}
          color={colors.white}
          fontSize="12px"
          fontWeight={400}
          pt={1}
          pb={1}
          px={2}
          gap="4px"
          onClick={() => !conciliado && setIsOpenModal(true)}
          cursor={!conciliado ? "pointer" : undefined}
          mb={mb}
        >
          {!conciliado ? <FaSearch size={18} /> : null}
          {conciliado ? "Conciliado" : "Encontrar lançamento"}
        </Tag>
      ) : null}

      {isOpenModal ? (
        <ModalConciliar
          valor={valor}
          visible={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          operacao={operacao}
          extratoId={extratoId}
          extratoData={extratoData}
          mes={mes}
          refetch={refetch}
          tenantContaIdExtrato={tenantContaIdExtrato}
          contasBancariasIds={contasBancariasIds}
        />
      ) : null}
    </>
  );
}

export default TagStatusConciliacao;
